// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"801":"26abbb5d","871":"9950b772","930":"62746cff"}[chunkId] + ".chunk.js";
};